import { OpenAI } from "openai";

// 直接创建 OpenAI 实例，使用固定配置
export const openai = () => {
  return new OpenAI({
    baseURL: "https://open.bigmodel.cn/api/paas/v4/",
    apiKey: "5b691a47c9908a63f2937a4cbb84b935.MZ81D1Ghvxbw9wLg",
    dangerouslyAllowBrowser: true,
  });
};
